namespace('compass.hotel');

compass.requireLib('compass.util.parse');

compass.hotel.ReservationManager = function ReservationManager(dates) {

	var _nights = _.map(dates, function (date) {
		return compass.util.parse.ISODateParser(date);
	});
	var _reservations = [ ];
	var iterations = 0;

	this.addReservation = function(stays, nights, roomType) {
		iterations += 1;
		var totals = _.foldl(stays, function(acc, stay) {
			var numNights = Number(stay.summary.numNights);
			var rooms = Number(stay.summary.numRooms);
			var avgRate = Number(stay.summary.avgRate);
			var cost = Number(stay.summary.totalCost);
			var taxes = Number(stay.summary.additFees);
			var guarantee = Number(stay.summary.guarantee);
			var charged = Number(stay.summary.chargedAmount);
			var serviceFee = Number(stay.summary.serviceFeeAmount);

			acc.nights += numNights;
			acc.rooms += rooms;
			acc.roomNights += rooms * numNights;
			acc.rateSum += (acc.roomNights * avgRate);
			acc.cost += cost;
			acc.taxes += taxes;
			acc.guarantee += guarantee;
			acc.charged += charged;
			acc.serviceFee += serviceFee;

			return acc;
		}, {
			nights : 0,
			rooms : 0,
			roomNights : 0,
			rateSum : 0,
			cost : 0,
			taxes : 0,
			guarantee : 0,
			charged : 0,
			serviceFee : 0
		});

		_reservations.push({
			stays : stays,
			nights : nights,
			roomType : roomType,
			totals : totals
		});
	};

	this.getStays = function() {
		return _.flatten(_.map(_reservations, function(r) { return r.stays; }));
	};

	this.getIterations = function() {
		return iterations;
	};

	this.getRoomTypeTotals = function() {
		function nightComparator(n) { return Number(n.date.replace(/-/g, '')); }
		var grouped = _.groupBy(_reservations, function(r) { return r.roomType.roomTypeName; });
		var mapped = _.map(grouped, function(rs) {
			var nights = _.flatten(_.map(rs, function(r) { return r.nights; }));
			var minNight = _.min(nights, nightComparator);
			var maxNight = _.max(nights, nightComparator);
			return {
				stays : _.flatten(_.map(rs, function(r) { return r.stays; })),
				roomType : _.head(_.map(rs, function(r) { return r.roomType; })),
				nights : _.filter(nights, function(n) {
					return n.fulldate >= minNight.fulldate && n.fulldate <= maxNight.fulldate;
				}),
				totals : _.foldl(_.map(rs, function(r) { return r.totals; }), function(acc, t) {
					acc.nights += t.nights;
					acc.rooms += t.rooms;
					acc.roomNights += t.roomNights;
					acc.rateSum += t.rateSum;
					acc.cost += t.cost;
					acc.taxes += t.taxes;
					acc.guarantee += t.guarantee;
					acc.charged += t.charged;
					acc.serviceFee += t.serviceFee;

					return acc;
				}, {
					nights : 0,
					rooms : 0,
					roomNights : 0,
					rateSum : 0,
					cost : 0,
					taxes : 0,
					guarantee : 0,
					charged : 0,
					serviceFee: 0
				})
			};
		});

		return mapped;
	};

};

